/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmBatchesList } from "../../funcs/llmBatchesList.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListBatchesRequest$inboundSchema,
};

export const tool$llmBatchesList: ToolDefinition<typeof args> = {
  name: "llm-batches-list",
  description: `List batches

Returns a paginated list of batches owned by the authenticated user.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmBatchesList(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
